// How long the success page waits for the registration to appear on the
// account. The Stripe webhook creates the organization and writes the pointer
// on `users/{uid}`, which the app context watches, so the wait ends as soon as
// that write lands.
export const CONFIRM_TIMEOUT_MS = 20000;

// What the registration success page shows.
//
// PURE. The page used to render "Registration Complete!" for anybody who
// opened the URL: it read the Stripe session id but never required it, and it
// had no sign-in guard, so a shared or bookmarked link claimed a payment that
// never happened.
//
// The success state now needs all three: a signed-in visitor, the session id
// Stripe returns, and an organization on the account. The browser cannot
// verify a session id by itself, so the organization is what proves the
// payment: only the webhook writes it.
export function registerSuccessState({
  authLoading,
  isAuthenticated,
  user,
  sessionId,
  waitedOut,
} = {}) {
  if (authLoading) {
    return 'loading';
  }
  if (!isAuthenticated || !sessionId) {
    return 'not-found';
  }
  if (user && user.organizationId) {
    return 'complete';
  }
  // Signed in and back from Stripe, but the webhook has not landed yet.
  return waitedOut ? 'not-found' : 'confirming';
}

export default registerSuccessState;
